module.exports = __webpack_public_path__ + "static/media/events.95be2075.png";